// Guia "Como usar" (texto 08, C2): os ✓ "já fiz" de cada passo, guardados NESTE aparelho (como lib/recolher.ts).
// O app nunca marca sozinho: só a pessoa marca e desmarca.
import { useSyncExternalStore } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';

const CHAVE = 'mp_guia_feitos';
let estado: Record<string, string[]> = {};   // página -> ids dos passos feitos
const ouvintes = new Set<() => void>();
const avisar = () => ouvintes.forEach(f => f());
const gravar = () => AsyncStorage.setItem(CHAVE, JSON.stringify(estado)).catch(() => {});

AsyncStorage.getItem(CHAVE).then(s => {
  if (!s) return;
  try { const g = JSON.parse(s); if (g && typeof g === 'object') { estado = { ...g, ...estado }; avisar(); } } catch { /* guardado inválido: ignora */ }
}, () => {});

export function marcarPasso(pagina: string, passo: string, feito: boolean) {
  const atual = new Set(estado[pagina] ?? []);
  if (feito) atual.add(passo); else atual.delete(passo);
  estado = { ...estado, [pagina]: [...atual] };
  avisar(); gravar();
}
export function limparMarcas(pagina: string) {
  if (!estado[pagina]?.length) return;
  const { [pagina]: _x, ...resto } = estado;
  estado = resto;
  avisar(); gravar();
}
const assinar = (cb: () => void) => { ouvintes.add(cb); return () => { ouvintes.delete(cb); }; };
const NADA: string[] = [];
/** Passos feitos da página. */
export function useFeitos(pagina: string): string[] {
  return useSyncExternalStore(assinar, () => estado[pagina] ?? NADA);
}
